/**
 * Rounds a number to the given precision, accounting for JavaScript float-point weirdness
 * @param number A number to round
 * @param precision The decimal precision to round to
 */
export function round(number: number, precision: number = 2) {
   const r = 0.5 * Number.EPSILON * number;
   // a while loop is faster than Math.pow() and the exponentiation operator, but *barely* (~1%),
   // and the exponentiation operator is more readable - if you need extreme performance, look elsewhere
   let order = 10 ** precision;
   if (number < 0) {
      order *= -1;
   }
   return Math.round((number + r) * order) / order;
}
